import { render, staticRenderFns } from "./sizing-row.vue?vue&type=template&id=71183ce7&"
import script from "./sizing-row.vue?vue&type=script&lang=js&"
export * from "./sizing-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports